// removed by extract-text-webpack-plugin
module.exports = {"favorite-product-box":"favorite-product-box","product":"product","box-wrap":"box-wrap","delete-favorite-product":"delete-favorite-product"};


//////////////////
// WEBPACK FOOTER
// ./components/users/sub-view/favorite-product-content/_FavoriteProductContent.scss
// module id = ./components/users/sub-view/favorite-product-content/_FavoriteProductContent.scss
// module chunks = 0